import React from 'react';
import {Message, Button, Grid, Header} from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';
import {unvalidatedBasicForm} from 'utils/helpers';
import config from './profileFormConfig';
import {EmptyFunc} from 'utils/DBUtils';

const ProfilePageForm = unvalidatedBasicForm(config);

const ProfilePage = (props) => {
  return (
    <div className='user-profile-page'>
      <Grid>
        <Grid.Column width={4}></Grid.Column>
        <Grid.Column width={8}>
          <Header as='h1'>
            <FormattedMessage id='userProfile.header1' />
          </Header>
          <Header as='h2'>
            <FormattedMessage id='userProfile.header2' />
          </Header>
          <FormattedMessage id='userProfile.description' />
          <Message info>
            <Message.Header className='user-group-indicator'>
              <FormattedMessage
                id='userProfile.groupName'
                values={{
                  groupName: <strong>{props.userGroupName}</strong>
                }} />
            </Message.Header>
          </Message>
          <ProfilePageForm
            onValueChanged={props.onValueChanged}
            onValidationError={props.onValidationError}
            errors={props.errors}
            data={props.formData} />
          <br/>
          <Button primary onClick={props.submit}>
            <FormattedMessage id='userProfile.submit' />
          </Button>
        </Grid.Column>
        <Grid.Column width={4}></Grid.Column>
      </Grid>
    </div>
  );
};

ProfilePage.defaultProps = {
  onValueChanged: EmptyFunc
};

export default ProfilePage;



// WEBPACK FOOTER //
// ./public/pages/Profile/ProfilePage.jsx